import AddAppointment from "components/appointment/AddAppointment";
import AddLunchSheduleModal from "components/lunch/AddLunch";
import { AddEncounterModal } from "components/ReplicateScheduleModal";
import { usePermissions } from "layouts/Admin";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "reactstrap";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup, setAddAppointmentPopup } from "slices/appointmentSlice";
import { fetchDashboardAnalytics } from "slices/dashboardSlice";
import { fetchDashboardAppointments } from "slices/dashboardSlice";
import { FaUtensils } from "react-icons/fa";
import LunchStatusSwitch from "components/lunchSwitch/lunchSwitch";
import { fetchLunchSchedule } from "slices/citySlice";

let userSlice;
function Header(props) {

  const [color] = React.useState("transparent");
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [lunchShuduleModal, setlunchShuduleModal] = React.useState({
    show: false,
    item: {}
  });
  const { lunchSchedule } = useSelector((state) => state.city);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);
  const [lunchStatus, setlunchStatus] = useState([]);

  const refDropdown = React.useRef(null);
  useEffect(() => {
    dispatch(fetchLunchSchedule(false, true)).then((res) => {
      setlunchStatus(res?.data);
    });
  }, [dispatch]);

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    dispatch(userSlice.logout());
    navigate("/login", { replace: true });
  };

  const handleClose = () => {
    dispatch(closeAppointmentPopup());
  };
  const handleLunchClose = () => {
    setlunchShuduleModal({
      show: false,
      item: {}
    });
  };

  const callback = () => {
    handleClose();
    appointmentPopUpState?.callback && appointmentPopUpState?.callback();
    dispatch(fetchDashboardAnalytics());
    dispatch(fetchDashboardAppointments());
  };

  const handleAddAppointmentPopUp = (item) => {
    dispatch(
      setAddAppointmentPopup({
        show: true,
        item,
      })
    );
  };

  return (
    <>
    <AddEncounterModal
      show={appointmentPopUpState.show}
      item={appointmentPopUpState.item}
      onClose={handleClose}
      afterUpdated={callback}

    />
      {/* <AddAppointment
        item={appointmentPopUpState.item}
        show={appointmentPopUpState.show}
        onClose={handleClose}
        callback={callback}
      /> */}
      <AddLunchSheduleModal
        item={lunchShuduleModal.item}
        show={lunchShuduleModal.show}
        onClose={handleLunchClose}
        callback={callback}
      />
      <Navbar
        expand="lg"
        className={
          location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute border-0 fixed-top"
            : "navbar-absolute border-0 fixed-top " +
            (color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <div className="header">
          <button className="toggle_sidebar" onClick={props.toggleSidebar}>
            <img src="/images/ham.png" alt="" />
          </button>

          <div className="row_user_side">
            {/* {checkPermission('Add Appointments') &&
              <button
                className="main_button"
                onClick={() => handleAddAppointmentPopUp()}
                // data-bs-toggle="modal"
                // data-bs-target="#addAppointmentPopUp"
                type="button"
              >
                New Appointment
              </button>
            } */}
            <LunchStatusSwitch userLunchStatus={lunchStatus} />
            <button 
              onClick={() => setlunchShuduleModal({item:{},show:true})} 
              style={{ height: "38px" , width: "38px" , borderRadius: "50px" ,border: "none", cursor: "pointer" }}
            >
              <FaUtensils size={22} color="#C6C3BD" />
            </button>
            <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
              <button className="user_image" onClick={toggleDropdown}>
                <img src="/images/default-person.png" alt="" />
                <span></span>
              </button>

              <button
                className={`drop_icon ${dropdownOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              >
                <img src="/images/drop.png" alt="" />
              </button>

              <div
                className={`drop_more_selector ${dropdownOpen ? "active" : ""
                  }`}
              >
                <ul>
                  {/* <li>
                    <Link href="#!">Profile</Link>
                  </li> */}
                  {checkPermission('Change Password') &&
                    <li>
                      <Link to="/change-password">Change Password</Link>
                    </li>
                  }
                  <li>
                    <Link target="_blank" href="https://algovisolutions.com/">Help</Link>
                  </li>
                  <li>
                    <a
                      href=""
                      onClick={handleLogout}
                      className="red_clr"
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
}

export default Header;
